import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { getFooterConfig } from '../firebase/services';

export default function Footer() {
  const [footerData, setFooterData] = useState({
    email: 'support@vetcare.com',
    phone: '015 5355 5330',
    address: 'Damanhour - El-Rowainy St. off Abd El-Salam El-Shazly St.',
    facebook: 'https://www.facebook.com/vetcare11',
    instagram: 'https://www.instagram.com/vet.care.clinic',
    tiktok: 'https://www.tiktok.com/@.vetcare3',
    whatsapp: 'https://wa.me/+201553555330'
  });

  useEffect(() => {
    const fetchFooterConfig = async () => {
      const config = await getFooterConfig();
      if (config) {
        setFooterData(prev => ({ ...prev, ...config }));
      }
    };
    fetchFooterConfig();
  }, []);

  return (
    <footer className="footer" style={{ backgroundImage: "url('/assets/images/footer-bg.jpg')" }}>
      <div className="footer-top section">
        <div className="container">

          <div className="footer-brand">

            <Link to="/" className="logo">
              <img src="/assets/images/footer_logo.png" alt="VetCare Logo" style={{ width: '100px' }} />
            </Link>

            <p className="footer-text">
              If you have any question, please contact us at <a href={`mailto:${footerData.email}`} className="link">{footerData.email}</a>
            </p>

            <ul className="contact-list">

              <li className="contact-item">
                <ion-icon name="location-outline" aria-hidden="true"></ion-icon>
                <address className="address">
                  {footerData.address}
                </address>
              </li>

              <li className="contact-item">
                <ion-icon name="call-outline" aria-hidden="true"></ion-icon>
                <a href={`tel:${footerData.phone}`} className="contact-link">{footerData.phone}</a>
              </li>

            </ul>

            <ul className="social-list">
              {footerData.facebook && (
                <li>
                  <a href={footerData.facebook} className="social-link" target="_blank" rel="noreferrer">
                    <ion-icon name="logo-facebook"></ion-icon>
                  </a>
                </li>
              )}
              {footerData.instagram && (
                <li>
                  <a href={footerData.instagram} className="social-link" target="_blank" rel="noreferrer">
                    <ion-icon name="logo-instagram"></ion-icon>
                  </a>
                </li>
              )}
              {footerData.tiktok && (
                <li>
                  <a href={footerData.tiktok} className="social-link" target="_blank" rel="noreferrer">
                    <ion-icon name="logo-tiktok"></ion-icon>
                  </a>
                </li>
              )}
              {footerData.whatsapp && (
                <li>
                  <a href={footerData.whatsapp} className="social-link" target="_blank" rel="noreferrer">
                    <ion-icon name="logo-whatsapp"></ion-icon>
                  </a>
                </li>
              )}
            </ul>

          </div>

          <ul className="footer-list">
            <li>
              <p className="footer-list-title">Corporate</p>
            </li>
            <li>
              <Link to="/about" className="footer-link">About Us</Link>
            </li>
            <li>
              <Link to="/contact" className="footer-link">Contact Us</Link>
            </li>
            <li>
              <Link to="/faq" className="footer-link">FAQs</Link>
            </li>
          </ul>

          <ul className="footer-list">
            <li>
              <p className="footer-list-title">Information</p>
            </li>
            <li>
              <Link to="/shop" className="footer-link">Online Store</Link>
            </li>
            <li>
              <Link to="/privacy-policy" className="footer-link">Privacy Policy</Link>
            </li>
            <li>
              <Link to="/refund-policy" className="footer-link">Refund Policy</Link>
            </li>
            <li>
              <Link to="/shipping-policy" className="footer-link">Shipping Policy</Link>
            </li>
            <li>
              <Link to="/terms" className="footer-link">Terms of Service</Link>
            </li>
          </ul>

        </div>
      </div>

      <div className="footer-bottom">
        <div className="container">
          <p className="copyright">
            &copy; 2025 VetCare. All Rights Reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
